<div class="modal-header">
  <h3>
    {{
      CompanyFeeForm && CompanyFeeForm.controls.id.value !== null
        ? 'Edit'
        : 'Add'
    }}
    Company Fee
  </h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  @if (CompanyFeeForm) {
    <form [formGroup]="CompanyFeeForm">
      <div class="row">
        <!-- Told this is not needed anymore -->
        <!-- <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="rank" class="form-label" requiredAsterisk>Rank</label>
          <select id="rank" type="text" class="form-select" formControlName="CompanyRankingId">
            <option selected disabled [ngValue]="null">Pick one...</option>
            <option *ngFor="let rank of CompanyRankings" [ngValue]="rank.id">{{ rank.rank }}</option>
          </select>
        </div>
      </div> -->
        <div class="col-12">
          <div class="form-group">
            <label for="feeType" class="form-label" requiredAsterisk
              >Fee Type</label
            >
            <select id="feeType" class="form-select" formControlName="feeType">
              <option selected disabled [ngValue]="null">Pick one...</option>
              @for (type of feeTypes; track type) {
                <option [ngValue]="type">
                  {{ type }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="row justify-content-center align-items-end">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label for="feeAmt" class="form-label" requiredAsterisk
              >Fee Amount</label
            >
            <input
              id="feeAmt"
              type="number"
              class="form-control"
              formControlName="feeAmt"
            />
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label for="remittanceAmt" class="form-label" requiredAsterisk
              >Remittance Amount</label
            >
            <input
              id="remittanceAmt"
              type="number"
              class="form-control"
              formControlName="remittanceAmt"
            />
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label for="discountAmt" class="form-label" requiredAsterisk
              >Discount Amount</label
            >
            <input
              id="discountAmt"
              type="number"
              class="form-control"
              formControlName="discountAmt"
            />
          </div>
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
